import useSearchAdministration from "./useSearchAdministration";

export default useSearchAdministration;
